import classNames from 'classnames';
import Icon from '../../atoms/Icon';
import PrimaryButton from '../../buttons/PrimaryButton';
import * as styles from './companyProfile.linaria';
import CompanyProfileContactPerson from './CompanyProfileContactPerson';
import CompanyProfileDescription from './CompanyProfileDescription';
import CompanyProfileHeader from './CompanyProfileHeader';
import CompanyProfileDetails from './CompanyProfileDetails/CompanyProfileDetails';
import CompanyProfileFeatures from './CompanyProfileFeatures';
import Alert from '../../molecules/Alert/Alert';
function CompanyProfile({ company, contactCompany, className, linkComponent, learnMoreAboutCertificatesURLPath, isPubliclyShared = false, }) {
    return (<div className={classNames([styles.style, className])}>
      <CompanyProfileHeader isPubliclyShared={isPubliclyShared} company={company} contactCompany={contactCompany}/>
      <div className={styles.CompanyProfile}>
      <div className='company-alert-section'>
       {!company.isActive && (<Alert title={company.companyName + ' bruker ikke Boligmappa lenger. Selskapsinformasjonen kan derfor være utdatert.'} layout='inline' type='info'>
        </Alert>)}
        </div> 
        <div className="company-description-section company-card-wrapper">
          <CompanyProfileDescription company={company}/>
        </div>
        <div className="company-data-section">
          <div className="company-card-wrapper">
            <CompanyProfileDetails company={company} learnMoreAboutCertificatesURLPath={learnMoreAboutCertificatesURLPath} linkComponent={linkComponent}/>
          </div>
          <div className={classNames('company-contact-person-section', 'company-card-wrapper')}>
            <CompanyProfileContactPerson company={company}/>
          </div>
        </div>

        <div className={classNames('company-feature-section company-card-wrapper')}>
          <CompanyProfileFeatures company={company}/>
        </div>
      </div>
      {!isPubliclyShared && (<div className={styles.contactButtonWrapper}>
          <PrimaryButton fill onClick={() => contactCompany(company)} className="contact-button">
            <Icon icon="Chat" size="large"/>
          </PrimaryButton>
        </div>)}
    </div>);
}
export default CompanyProfile;
